// ─── Local da tarefa: fica na primeira linha das anotações ("📍 endereço"), como a agenda do Google usa ───
const MARCA = '📍 ';
export function separarLocal(notes: string) {
  const l = (notes ?? '').split('\n');
  return l[0]?.startsWith(MARCA) ? { local: l[0].slice(MARCA.length).trim(), resto: l.slice(1).join('\n') } : { local: '', resto: notes ?? '' };
}
export const juntarLocal = (local: string, resto: string) => (local.trim() ? `${MARCA}${local.trim()}${resto.trim() ? '\n' + resto : ''}` : resto);
export const localDaTarefa = (notes: string) => separarLocal(notes).local;
